<template>
  <div style="position: relative;">
    <div class="about-background__color--overlay"></div>
    <particles class="about-gradient">
      <home-toolbar></home-toolbar>

      <div class="content--about text-xs-center hide-on-hover">
        <v-container fluid grid-list-lg>
          <v-layout row wrap justify-center align-center>
            <v-flex md6 xs12>
              <div data-aos="zoom-in" data-aos-easing="ease">
                <h1 class="display-2 mb-4">
                  <strong>{{ __('Cyber Defence Academy (“CDA”) is a brand of SSA Academy.') }}</strong>
                </h1>

                <v-btn large color="secondary" target="__blank" href="http://ssa.academy/">
                  {{ __('Visit SSA Academy') }}
                </v-btn>
              </div>
            </v-flex>
          </v-layout>
        </v-container>
      </div>
    </particles>
  </div>
</template>

<script>
export default {
  name: 'Banner',
}
</script>
